import { GeographicEntityListPage } from '@/components/geographic/GeographicEntityListPage'
import { geographicEntities } from '@/config/geographicEntities'

export default function TownsPage() {
  return <GeographicEntityListPage config={geographicEntities.towns} />
}
